import React, { FormEvent } from 'react'
import { useForm, Link } from '@inertiajs/react'
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'
import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import { SidebarLayout } from '@/components/layouts/SidebarLayout'

export default function New() {
  const { data, setData, post, processing, errors } = useForm({
    project: {
      name: '',
      description: '',
    },
  })

  function handleSubmit(e: FormEvent) {
    e.preventDefault()
    post('/manage/projects')
  }

  return (
    <SidebarLayout section="manage" title="New project">
      <Paper
        elevation={0}
        sx={{
          p: { xs: 3, sm: 5 },
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 2,
          maxWidth: 600,
        }}
      >
        <Box component="form" onSubmit={handleSubmit} noValidate>
          <TextField
            label="Name"
            fullWidth
            autoFocus
            value={data.project.name}
            onChange={e => setData('project', { ...data.project, name: e.target.value })}
            error={'project.name' in errors}
            helperText={(errors as Record<string, string>)['project.name']}
            sx={{ mb: 2.5 }}
          />
          <TextField
            label="Description"
            fullWidth
            multiline
            minRows={3}
            value={data.project.description}
            onChange={e => setData('project', { ...data.project, description: e.target.value })}
            error={'project.description' in errors}
            helperText={(errors as Record<string, string>)['project.description'] || 'Optional description of this project'}
            sx={{ mb: 2.5 }}
          />
          <Button
            type="submit"
            variant="contained"
            fullWidth
            size="large"
            disabled={processing}
            sx={{ mb: 2 }}
          >
            Create project
          </Button>
          <Box sx={{ textAlign: 'center' }}>
            <Link href="/manage/projects" style={{ color: '#1a1a1a' }}>Back to projects</Link>
          </Box>
        </Box>
      </Paper>
    </SidebarLayout>
  )
}
